import {
    csParamKey,
    csUsageParamKey,
    invoiceItemParamKey,
    logParamKey,
    Route,
} from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export enum CompanyServiceRoute {
    Index = 'company.services.index',
    Create = 'company.services.create',
    Edit = 'company.services.edit',
    Clone = 'company.services.clone',
    EditRate = 'company.services.edit-rate',
    Usage = 'company.services.usage',
    UsageDetails = 'company.services.usage.details',
    UsageTariff = 'company.services.usage.tariff',
    UsageProvider = 'company.services.usage.provider',
    Invoices = 'company.services.invoices',
    InvoiceEdit = 'company.services.invoices.edit',
    InvoiceLogs = 'company.services.invoices.logs',
    Details = 'company.services.details',
    Logs = 'company.services.logs',
    LogDetails = 'company.services.logs.details',
}

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'name',
        direction: 'asc',
    })

    route.groupBy.value = 'rate'

    route.setLimit(999999)
}

export default {
    path: 'services',
    name: CompanyServiceRoute.Index,
    component: () => import('@/views/company/service/Index.vue'),
    meta: {
        label: 'Services',
        auth: true,
        permission: Permission.CompanyServiceViewAny,
    },
    children: [
        {
            path: 'create',
            name: CompanyServiceRoute.Create,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Create Service',
                auth: true,
                permission: Permission.CompanyServiceCreate,
            },
        },
        {
            path: `:${csParamKey}/edit`,
            name: CompanyServiceRoute.Edit,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Edit Service',
                auth: true,
                permission: Permission.CompanyServiceUpdate,
            },
        },
        {
            path: `:${csParamKey}/clone`,
            name: CompanyServiceRoute.Clone,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Clone Service',
                auth: true,
                permission: Permission.CompanyServiceCreate,
            },
        },
        {
            path: `:${csParamKey}/edit-rate`,
            name: CompanyServiceRoute.EditRate,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Edit Rate',
                auth: true,
                permission: Permission.CompanyServiceUpdate,
            },
        },
        {
            path: `:${csParamKey}/usage`,
            name: CompanyServiceRoute.Usage,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Usage',
                auth: true,
                permission: Permission.CompanyServiceUsageViewAny,
            },
            children: [
                {
                    path: `:${csUsageParamKey}/details`,
                    name: CompanyServiceRoute.UsageDetails,
                    component: () => import('@/views/company/service/Index.vue'),
                    meta: {
                        label: 'Usage Details',
                        auth: true,
                        permission: Permission.CompanyServiceUsageView,
                    },
                },
                {
                    path: `:${csUsageParamKey}/tariff`,
                    name: CompanyServiceRoute.UsageTariff,
                    component: () => import('@/views/company/service/Index.vue'),
                    meta: {
                        label: 'Usage Tariff',
                        auth: true,
                        permission: Permission.TariffView,
                    },
                },
                {
                    path: `:${csUsageParamKey}/provider`,
                    name: CompanyServiceRoute.UsageProvider,
                    component: () => import('@/views/company/service/Index.vue'),
                    meta: {
                        label: 'Usage Provider',
                        auth: true,
                        permission: Permission.ModuleView,
                    },
                },
            ],
        },
        {
            path: `:${csParamKey}/invoices`,
            name: CompanyServiceRoute.Invoices,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Invoices',
                auth: true,
                permission: Permission.CompanyServiceView,
            },
            children: [
                {
                    path: `:${invoiceItemParamKey}/edit`,
                    name: CompanyServiceRoute.InvoiceEdit,
                    component: () => import('@/views/company/service/Index.vue'),
                    meta: {
                        label: 'Invoice Edit',
                        auth: true,
                        permission: Permission.InvoiceItemUpdate,
                    },
                },
                {
                    path: `:${invoiceItemParamKey}/logs`,
                    name: CompanyServiceRoute.InvoiceLogs,
                    component: () => import('@/views/company/service/Index.vue'),
                    meta: {
                        label: 'Invoice Logs',
                        auth: true,
                        permission: Permission.InvoiceItemView,
                    },
                },
            ],
        },
        {
            path: `:${csParamKey}/details`,
            name: CompanyServiceRoute.Details,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Service Details',
                auth: true,
                permission: Permission.CompanyServiceView,
            },
        },
        {
            path: `:${csParamKey}/logs`,
            name: CompanyServiceRoute.Logs,
            component: () => import('@/views/company/service/Index.vue'),
            meta: {
                label: 'Service Logs',
                auth: true,
                permission: Permission.CompanyServiceView,
            },
            children: [
                {
                    path: `:${logParamKey}/details`,
                    name: CompanyServiceRoute.LogDetails,
                    component: () => import('@/views/company/service/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                    children: [],
                },
            ],
        },
    ],
}
